export default {
  name: "",
  cathegory: "main-hall",
  hall: {
    amphitheater: {
      14: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      13: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      12: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      11: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      10: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      9: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      8: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      7: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      6: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      5: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      4: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      3: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      2: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      1: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      }
    },
    parther: {
      1: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      2: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      3: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      4: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      5: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        },
        20: {
          price: -1,
          color: 8
        },
        21: {
          price: -1,
          color: 8
        }
      },
      6: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        }
      },
      7: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        }
      },
      8: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        }
      },
      9: {
        1: {
          price: -1,
          color: 8
        },
        2: {
          price: -1,
          color: 8
        },
        3: {
          price: -1,
          color: 8
        },
        4: {
          price: -1,
          color: 8
        },
        5: {
          price: -1,
          color: 8
        },
        6: {
          price: -1,
          color: 8
        },
        7: {
          price: -1,
          color: 8
        },
        8: {
          price: -1,
          color: 8
        },
        9: {
          price: -1,
          color: 8
        },
        10: {
          price: -1,
          color: 8
        },
        11: {
          price: -1,
          color: 8
        },
        12: {
          price: -1,
          color: 8
        },
        13: {
          price: -1,
          color: 8
        },
        14: {
          price: -1,
          color: 8
        },
        15: {
          price: -1,
          color: 8
        },
        16: {
          price: -1,
          color: 8
        },
        17: {
          price: -1,
          color: 8
        },
        18: {
          price: -1,
          color: 8
        },
        19: {
          price: -1,
          color: 8
        }
      }
    }
  }
}